module.exports = __webpack_public_path__ + "media/icons/icon-bar-2-fe8e0f50.png";